<template>
    <rkm-modal
        :loading="loading"
        large
        ref="Modal"
        title="Realocar para setor"
    >
        <rkm-form
            ref="Form"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="centrosCustoFiltered"
                        :validations="validations.centroCusto"
                        label="Setor"
                        show-default-option
                        text-field="setorNome"
                        v-model="model.centroCustoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template
            v-slot:footer="{ cancel }"
        >
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.validate(save)"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {

            return {
                centroCusto: { required: true },
            }
        },
        centrosCustoFiltered() {

            return this.centrosCusto.filter(cc => cc.id !== this.centroCustoAtualId)
        }
    },
    data: () => ({
        centroCustoAtualId: null,
        callback: null,
        model: {
            centroCustoId: null
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(centroCustoAtualId, callback) {

            this.centroCustoAtualId = centroCustoAtualId
            this.callback = callback
            this.model.centroCustoId = null

            this.$refs.Modal.show()
        },
        save() {

            this.setLoading()

            this.callback(this.model.centroCustoId)
                .then(() => this.$refs.Modal.hide())
                .finally(() => this.unsetLoading())
        },
    },
    props: {
        centrosCusto: { type: Array, required: true },
    }
}
</script>